<template>
  <div id="help">
    <div class="div-1">
      I 准备工作
      <ul class="div-2">
        <li>安装Chrome浏览器，并且安装浏览器数字钱包插件；</li>
        <ul class="div-2">
          <p class="div-2">
            步骤1. 【chrome】请打开
            <a href="https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?hl=zh-CN">
              https://github.com/ChengOrangeJu/WebExtensionWallet
            </a>
            &nbsp;然后按照流程安装钱包到浏览器；
          </p>
          <p class="div-2">
            步骤2. 设置您的帐户，请妥善包括你到钱包密码和私钥文件；
          </p>
          <p class="div-2">
            步骤3. 代币请到 <a href="https://gate.io">火币网 gate.io</a> 购买兑换；
          </p>
        </ul>
        <li class="div-2">登录你的钱包，然后刷新当前页面，即可使用系统功能；</li>
      </ul>
    </div>

    <div class="div-1">
      I I  功能说明
      <li class="div-2">用户注册：首次登录钱包功后请注册，注意角色为【老师】或者【学生】； </li>
      <li class="div-2">作业展示：所有人的作业成果物展示； </li>
      <li class="div-2">作业发布：【老师】可以发布作业给自己的学生； </li>
      <li class="div-2">我的作业：
        <div class="div-2">
          【老师】查看布置作业以及完成情况，上传参考答案，对学生作业进行评分；<br>
          【学生】查看老师布置给自己的作业，完成并且提交作业；<br>
        </div>
      </li>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style scoped>
  #help .div-1 {
    text-align: left;
    margin: 20px;
  }
  #help .div-2 {
    text-align: left;
    margin-left: 20px;
    margin-top: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/base-help.vue